// types
type Types = any

const list: Types = {
  styleOverrides: {
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
}

export default list
